export const TEXT_MODELS = [
  { name: 'GPT-4 Turbo', value: "gpt-4-1106-preview" },
  { name: 'GPT-3.5 Turbo',  value:"gpt-3.5-turbo-1106" },
];

export const IMAGE_MODELS = [
  { name: 'DALL-E 3', value: "dall-e-3" },
  { name: 'DALL-E 2', value: "dall-e-2" },
];